import React from "react";
import { Link, useNavigate } from "react-router-dom";
import hand from "../../assets/img/icons/Waving Hand Light Skin Tone.svg";
import setting from "../../assets/img/admin/setting-2.svg";
import addUser from "../../assets/img/admin/user-add.svg";
import notAdd from "../../assets/img/admin/note-add.svg";
import notif from "../../assets/img/admin/notification.svg";
import message from "../../assets/img/icons/message-notif.svg";

import Button from "../shared/Button";
import moment from "jalali-moment";
import { useUserInfo } from "../../context/UserContext";
import SearchInput from "../layouts/admin/AdminShared/SearchInput";

const AdminMenu = () => {
    const navigate = useNavigate();
    const goToCreate=()=>navigate("/create");
    let todayJalali = moment().locale('fa').format('D  MMMM  YYYY');
    //YYYY/MM/DD
    const {userinfo}=useUserInfo()

  return (
    <div className="">
      <div className="UserPanelMenu AdminMenu">

       
        <div className="UserPanelMenu__helloProfile">
          <h6>سلام {userinfo.data.user.full_name} عزیز</h6>
          <img src={hand}/>
          <div>
          |
          </div>
          <p>      امروز {todayJalali}</p>
        </div>
        <div className="flex gap-[28px] items-center">
        <button onClick={()=>navigate('/')}><img src={addUser}/></button>
        <button onClick={()=>navigate('/')}><img src={setting}/></button>
        <button onClick={()=>navigate('/')}><img src={notAdd}/></button>


        </div>

        <div>
            <div className="flex gap-[36px] ">
                {/* <button><img src={message}/></button> */}
                <button onClick={()=>navigate('/user/notification')}><img src={notif}/></button>
                
            </div>
        </div>
      </div>
    </div>
  );
};



export default AdminMenu